{
    "Para1": "Selezionare il layout del dashboard dalle opzioni sottostanti:",
    "DashboardDisplaySettings_SectionHeader": "Impostazioni del display",
    "NAME": "DashboardDisplaySettings"
}